/**
 * WizardStepper
 *
 * Shared sub-header stepper strip used inside both:
 *   - AddTestCaseModal
 *   - DocumentToJiraWizard
 *
 * Props
 * ─────
 * steps        string[]  – Step labels
 * activeStep   number    – 0-based index of the current active step
 * labelSize    string    – Font size of step labels. Defaults to '12px'
 *
 * Migration notes
 * ───────────────
 * Both files define a local `WizardStepper` that is byte-for-byte identical
 * except for the label fontSize (12px vs 11px).  Replace both with this
 * shared version and pass `labelSize` when you need to override.
 *
 * AddTestCaseModal:
 *   <WizardStepper steps={stepperSteps} activeStep={stepperActive} />
 *
 * DocumentToJiraWizard:
 *   <WizardStepper steps={WIZARD_STEPS} activeStep={STEPPER_INDEX[screen]} labelSize="11px" />
 */

import { Box, Step, StepLabel, Stepper } from '@mui/material';

const WizardStepper = ({ steps, activeStep, labelSize = '12px' }) => (
  <Box sx={{ px: 2, pt: 1.5, pb: 0 }}>
    <Stepper activeStep={activeStep} alternativeLabel>
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel
            sx={{
              '& .MuiStepLabel-label': { fontSize: labelSize, fontWeight: 500 },
            }}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  </Box>
);

export default WizardStepper;